import classNames from 'classnames';
import React, { CSSProperties, memo, useMemo } from 'react';
import { Styled } from '../../types';

type FontAwesomeIconProps = CSSProperties &
  Styled & {
    name: string;
    size?: number;
  };

const FontAwesomeIcon = ({
  name: incomingName,
  size = 16,
  className = '',
  ...style
}: FontAwesomeIconProps) => {
  const name = useMemo(() => {
    let nextName = incomingName.replace(/^fas-/, 'fa-');
    nextName = `${!nextName.startsWith('fa-') ? 'fa-' : ''}${nextName}`;
    return nextName;
  }, [incomingName]);
  return (
    <i
      className={classNames('fa', name, className)}
      style={{
        fontSize: size,
        ...style
      }}
    />
  );
};

export default memo(FontAwesomeIcon);
